module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "specialAndOverlook-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.specialIB))])]), _vm._v(" "), _c('div', {
    staticClass: "specialIB-box"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    class: {
      'disabled': !_vm.enable || _vm.version == '0'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.multiLanguage.allLowIB))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.ibAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.ibName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.costPerCommission))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.operate))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.newSpecialIB), function(item, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.withSub),
        expression: "item.withSub"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enable || _vm.version == '0'
      },
      domProps: {
        "checked": Array.isArray(item.withSub) ? _vm._i(item.withSub, null) > -1 : (item.withSub)
      },
      on: {
        "input": function($event) {
          return _vm.withSubChecked(item)
        },
        "change": function($event) {
          var $$a = item.withSub,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "withSub", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "withSub", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "withSub", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ibId),
        expression: "item.ibId"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('numeric'),
        expression: "'numeric'"
      }],
      staticClass: "form-control",
      style: (_vm.errors.has(index + '_' + 'specialIbId') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.enable || _vm.version == '0',
        "name": index + '_' + 'specialIbId'
      },
      domProps: {
        "value": (item.ibId)
      },
      on: {
        "change": function($event) {
          _vm.checkIBFn(item, 'special', _vm.errors.has(index + '_' + 'specialIbId'))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ibId", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', _vm._l((item.value), function(lev, i) {
      return _c('div', {
        key: i,
        staticStyle: {
          "margin": "3px 0",
          "text-align": "left"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "90px",
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(lev.level == 0 ? _vm.ruleSettingLan.currentSetting : item.value.length - lev.level + _vm.ruleSettingLan.levelSetting))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (lev.rebate),
          expression: "lev.rebate"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: (lev.ibId ? 'required|min_value:0.00|decimal:2' : 'min_value:0.00|decimal:2'),
          expression: "lev.ibId ? 'required|min_value:0.00|decimal:2' : 'min_value:0.00|decimal:2'"
        }],
        staticClass: "form-control form-control-small",
        style: (_vm.errors.has(index + '_' + 'specialRebate') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enable || _vm.version == '0',
          "name": index + '_' + 'specialRebate'
        },
        domProps: {
          "value": (lev.rebate)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(lev, "rebate", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', [_c('el-button', {
        style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
        attrs: {
          "type": "warning",
          "size": "small",
          "disabled": !_vm.enable
        },
        on: {
          "click": function($event) {
            return _vm.removeItemLev(index, i, _vm.newSpecialIB)
          }
        }
      }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.remove))]), _vm._v(" "), (i == 0) ? _c('el-button', {
        style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
        attrs: {
          "type": "primary",
          "size": "small",
          "disabled": !_vm.enable
        },
        on: {
          "click": function($event) {
            return _vm.addItemLev(index, i, _vm.newSpecialIB)
          }
        }
      }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.add))]) : _vm._e()], 1)])
    }), 0), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-style-add",
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "disabled": !_vm.enable
      },
      on: {
        "click": function($event) {
          return _vm.addItem(index, _vm.newSpecialIB)
        }
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.add))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-style-remove",
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "disabled": !_vm.enable
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index, _vm.newSpecialIB)
        }
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.remove))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.overlookIB))])]), _vm._v(" "), _c('div', {
    staticClass: "overlookIB-box"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    class: {
      'disabled': !_vm.enable
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.multiLanguage.allLowIB))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.ibAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.ibName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.operate))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.newOverlookIB), function(item, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.withSub),
        expression: "item.withSub"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enable || _vm.version == '0'
      },
      domProps: {
        "checked": Array.isArray(item.withSub) ? _vm._i(item.withSub, null) > -1 : (item.withSub)
      },
      on: {
        "change": function($event) {
          var $$a = item.withSub,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "withSub", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "withSub", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "withSub", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ibId),
        expression: "item.ibId"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('numeric'),
        expression: "'numeric'"
      }],
      staticClass: "form-control",
      style: (_vm.errors.has(index + '_' + 'overlookIbId') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.enable || _vm.version == '0',
        "name": index + '_' + 'overlookIbId'
      },
      domProps: {
        "value": (item.ibId)
      },
      on: {
        "change": function($event) {
          _vm.checkIBFn(item, 'ignore', _vm.errors.has(index + '_' + 'overlookIbId'))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ibId", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-style-add",
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "disabled": !_vm.enable
      },
      on: {
        "click": function($event) {
          return _vm.addItem(index, _vm.newOverlookIB)
        }
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.add))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-style-remove",
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "disabled": !_vm.enable
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index, _vm.newOverlookIB)
        }
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.remove))])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61ba6476","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/Sale/SaleSetting/specialAndOverlook.vue
// module id = 1120
// module chunks = 1